var map = {
	"./abi_ch_aegisofyellowfire.png": 24,
	"./abi_ch_aethyricshock.png": 25,
	"./abi_ch_ageisoforangefire.png": 26,
	"./abi_ch_agonizingtorrent.png": 27,
	"./abi_ch_ascendance.png": 28,
	"./abi_ch_balefultransmogrification.png": 29,
	"./abi_ch_baneful shielding.png": 30,
	"./abi_ch_banefulclutch.png": 31,
	"./abi_ch_befuddlinggreenfire.png": 32,
	"./abi_ch_bewilderpursuer.png": 33,
	"./abi_ch_bladedmutation.png": 34,
	"./abi_ch_blastwave.png": 35,
	"./abi_ch_bloodyspin.png": 36,
	"./abi_ch_boltofchange.png": 37,
	"./abi_ch_boonoftzeentch.png": 38,
	"./abi_ch_breathoftzeentch.png": 39,
	"./abi_ch_challenge.png": 40,
	"./abi_ch_chaoticcrippling.png": 41,
	"./abi_ch_chaoticontamination.png": 42,
	"./abi_ch_chaoticrift.png": 43,
	"./abi_ch_charge.png": 44,
	"./abi_ch_circleofsummoning.png": 45,
	"./abi_ch_clawingmutation.png": 46,
	"./abi_ch_cleave.png": 47,
	"./abi_ch_clingingchaos.png": 48,
	"./abi_ch_concussivejolt.png": 49,
	"./abi_ch_conduitofchaos.png": 50,
	"./abi_ch_convulsiveslashing.png": 51,
	"./abi_ch_corrosivegreyfire.png": 52,
	"./abi_ch_corruptinghorror.png": 53,
	"./abi_ch_corruptingtouch.png": 54,
	"./abi_ch_cowerbeforetzeentch.png": 55,
	"./abi_ch_crushingmutation.png": 56,
	"./abi_ch_cunningstrike.png": 57,
	"./abi_ch_curseoffear.png": 58,
	"./abi_ch_curseofrepulsion.png": 59,
	"./abi_ch_curseofterror.png": 60,
	"./abi_ch_curseofwarpedearth.png": 61,
	"./abi_ch_curseofwithering.png": 62,
	"./abi_ch_daemonicfortitude.png": 63,
	"./abi_ch_daemonicscream.png": 64,
	"./abi_ch_darkcleansing.png": 65,
	"./abi_ch_darkmedicine.png": 66,
	"./abi_ch_darkperiapt.png": 67,
	"./abi_ch_deathgrip.png": 68,
	"./abi_ch_deepercunning.png": 69,
	"./abi_ch_demolition.png": 70,
	"./abi_ch_demonicarmor.png": 71,
	"./abi_ch_demonicconsumption.png": 72,
	"./abi_ch_demonicfire.png": 73,
	"./abi_ch_demonicinfestation.png": 74,
	"./abi_ch_demoniclash.png": 75,
	"./abi_ch_demonicmaw.png": 76,
	"./abi_ch_demonicresistance.png": 77,
	"./abi_ch_demonspittle.png": 78,
	"./abi_ch_denyknowledge.png": 79,
	"./abi_ch_denystrength.png": 80,
	"./abi_ch_denyvitality.png": 81,
	"./abi_ch_despairingblackfire.png": 82,
	"./abi_ch_destinedforvictory.png": 83,
	"./abi_ch_devastatingindigofire.png": 84,
	"./abi_ch_dimensionalinstability.png": 85,
	"./abi_ch_discblast.png": 86,
	"./abi_ch_discordantturbulence.png": 87,
	"./abi_ch_discshock.png": 88,
	"./abi_ch_dismissal.png": 89,
	"./abi_ch_dissolvingblast.png": 90,
	"./abi_ch_dissolvingmist.png": 91,
	"./abi_ch_downfall.png": 92,
	"./abi_ch_drainingswipe.png": 93,
	"./abi_ch_dustofpandemonium.png": 94,
	"./abi_ch_eruption.png": 95,
	"./abi_ch_exchangevitality.png": 96,
	"./abi_ch_exhaustivepower.png": 97,
	"./abi_ch_eyesofsheerian.png": 98,
	"./abi_ch_ferociousassault.png": 99,
	"./abi_ch_firewyrmoftzeentch.png": 100,
	"./abi_ch_flail.png": 101,
	"./abi_ch_flameoftzeentch.png": 102,
	"./abi_ch_flamesofchange.png": 103,
	"./abi_ch_flamesoffate.png": 104,
	"./abi_ch_flawlessarmor.png": 105,
	"./abi_ch_flingredfire.png": 106,
	"./abi_ch_forcelance.png": 107,
	"./abi_ch_forkedaggression.png": 108,
	"./abi_ch_giftofrelease.png": 109,
	"./abi_ch_gleanmagic.png": 110,
	"./abi_ch_glimpseofchaos.png": 111,
	"./abi_ch_goldeneyeoftzeentch.png": 112,
	"./abi_ch_graspingdarkness.png": 113,
	"./abi_ch_guard.png": 114,
	"./abi_ch_guillotine.png": 115,
	"./abi_ch_gutripper.png": 116,
	"./abi_ch_hamstring.png": 117,
	"./abi_ch_horrifyingvisions.png": 118,
	"./abi_ch_imminentdoom.png": 119,
	"./abi_ch_impale.png": 120,
	"./abi_ch_indigofireofchange.png": 121,
	"./abi_ch_inevitablechanging.png": 122,
	"./abi_ch_infallibleprotection.png": 123,
	"./abi_ch_infernalblast.png": 124,
	"./abi_ch_instability.png": 125,
	"./abi_ch_invokeorangefire.png": 126,
	"./abi_ch_lashingpower.png": 127,
	"./abi_ch_markofdaemonicfury.png": 128,
	"./abi_ch_markofdarkglory.png": 129,
	"./abi_ch_markofspelldestroyer.png": 130,
	"./abi_ch_markofthedaemonichero.png": 131,
	"./abi_ch_markofthespelldestroy.png": 132,
	"./abi_ch_markofthevortex.png": 133,
	"./abi_ch_markoftzeentchsrebirth.png": 134,
	"./abi_ch_markoftzeentchswill.png": 135,
	"./abi_ch_markofvortex.png": 136,
	"./abi_ch_mercurialspeed.png": 137,
	"./abi_ch_mirrorofmadness.png": 138,
	"./abi_ch_mouthoftzeentch.png": 139,
	"./abi_ch_mutatedaggressor.png": 140,
	"./abi_ch_mutatedenergy.png": 141,
	"./abi_ch_mutatingrelease.png": 142,
	"./abi_ch_overwhelmingterror.png": 143,
	"./abi_ch_pandemonium.png": 144,
	"./abi_ch_paralyzingterror.png": 145,
	"./abi_ch_perilsofthewarp.png": 146,
	"./abi_ch_petrify.png": 147,
	"./abi_ch_plunderingpower.png": 148,
	"./abi_ch_potionoofpaindenied.png": 149,
	"./abi_ch_powervortex.png": 150,
	"./abi_ch_pulverize.png": 151,
	"./abi_ch_quake.png": 152,
	"./abi_ch_quellthespirit.png": 153,
	"./abi_ch_quickenedferocity.png": 154,
	"./abi_ch_ravage.png": 155,
	"./abi_ch_reckoningoftzeentch.png": 156,
	"./abi_ch_relentless.png": 157,
	"./abi_ch_rend.png": 158,
	"./abi_ch_rendingblade.png": 159,
	"./abi_ch_rendwinds.png": 160,
	"./abi_ch_reversaloffate.png": 161,
	"./abi_ch_rightofagonies.png": 162,
	"./abi_ch_riteofresilence.png": 163,
	"./abi_ch_ritualofexhaustion.png": 164,
	"./abi_ch_ritualofexsanguination.png": 165,
	"./abi_ch_ritualoffragility.png": 166,
	"./abi_ch_ritualoflethargy.png": 167,
	"./abi_ch_ritualoflunacy.png": 168,
	"./abi_ch_ritualofvulnerability.png": 169,
	"./abi_ch_roilingwinds.png": 170,
	"./abi_ch_ruinousguardian.png": 171,
	"./abi_ch_seedofchaos.png": 172,
	"./abi_ch_siphonvitality.png": 173,
	"./abi_ch_slash.png": 174,
	"./abi_ch_stormofravens.png": 175,
	"./abi_ch_strengthenthrall.png": 176,
	"./abi_ch_summonbluehorror.png": 177,
	"./abi_ch_summonflamer.png": 178,
	"./abi_ch_summonpinkhorror.png": 179,
	"./abi_ch_surgeofinsanity.png": 180,
	"./abi_ch_surgingbluefire.png": 181,
	"./abi_ch_surgingvioletfire.png": 182,
	"./abi_ch_swataside.png": 183,
	"./abi_ch_taintedclaw.png": 184,
	"./abi_ch_taunt.png": 185,
	"./abi_ch_tenacioustendrils.png": 186,
	"./abi_ch_terribleembrace.png": 187,
	"./abi_ch_theftofwords.png": 188,
	"./abi_ch_thegreatfang.png": 189,
	"./abi_ch_throw.png": 190,
	"./abi_ch_throwaxe.png": 191,
	"./abi_ch_throwingaxe.png": 192,
	"./abi_ch_thunderousblow.png": 193,
	"./abi_ch_toothoftzeentch.png": 194,
	"./abi_ch_touchofpalsy.png": 195,
	"./abi_ch_tremblingweakness.png": 196,
	"./abi_ch_tumultuouswarping.png": 197,
	"./abi_ch_tzeenchsamplifaction.png": 198,
	"./abi_ch_tzeentchcordial.png": 199,
	"./abi_ch_tzeentchscream.png": 200,
	"./abi_ch_tzeentchsfirestorm.png": 201,
	"./abi_ch_tzeentchsgrip.png": 202,
	"./abi_ch_tzeentchshallremakeyou.png": 203,
	"./abi_ch_tzeentchslash.png": 204,
	"./abi_ch_tzeentchsplan.png": 205,
	"./abi_ch_tzeentchsreflection.png": 206,
	"./abi_ch_tzeentchsrestoration.png": 207,
	"./abi_ch_tzeentchsreversal.png": 208,
	"./abi_ch_tzeentchsspark.png": 209,
	"./abi_ch_tzeentchsvision.png": 210,
	"./abi_ch_unbound.png": 211,
	"./abi_ch_uncontrollablewarping.png": 212,
	"./abi_ch_unstablepower.png": 213,
	"./abi_ch_veilofchaos.png": 214,
	"./abi_ch_violetfire.png": 215,
	"./abi_ch_visionofmadness.png": 216,
	"./abi_ch_warpfire.png": 217,
	"./abi_ch_warpfrenzy.png": 218,
	"./abi_ch_warpingblast.png": 219,
	"./abi_ch_warpingenergy.png": 220,
	"./abi_ch_warpreality.png": 221,
	"./abi_ch_waveofhorror.png": 222,
	"./abi_ch_waveofmutilation.png": 223,
	"./abi_ch_waveofterror.png": 224,
	"./abi_ch_windblock.png": 225,
	"./abi_ch_withersoul.png": 226,
	"./abi_ch_wreckingball.png": 227,
	"./abi_ch_zap.png": 228,
	"./abi_de_absorbvitality.png": 229,
	"./abi_de_agileescape.png": 230,
	"./abi_de_agonizingwound.png": 231,
	"./abi_de_armorofeternalservitude.png": 232,
	"./abi_de_awaycretins.png": 233,
	"./abi_de_banishweakness.png": 234,
	"./abi_de_befuddlingstrike.png": 235,
	"./abi_de_bestowvitality.png": 236,
	"./abi_de_blackhorror.png": 237,
	"./abi_de_blacklotusblade.png": 238,
	"./abi_de_bladeofruin.png": 239,
	"./abi_de_bladespin.png": 240,
	"./abi_de_blastofhatred.png": 241,
	"./abi_de_bloodoffering.png": 242,
	"./abi_de_bolsteringanger.png": 243,
	"./abi_de_brutalsmash.png": 244,
	"./abi_de_cataclysmicdarkness.png": 245,
	"./abi_de_challenge.png": 246,
	"./abi_de_chillwind.png": 247,
	"./abi_de_chokingfury.png": 248,
	"./abi_de_cleavesoul.png": 249,
	"./abi_de_consumeessence.png": 250,
	"./abi_de_consumeresolve.png": 251,
	"./abi_de_consumestrength.png": 252,
	"./abi_de_consumewill.png": 253,
	"./abi_de_covenantofcelerity.png": 254,
	"./abi_de_covenantoftenacity.png": 255,
	"./abi_de_covenantofvitality.png": 256,
	"./abi_de_crimsondeath.png": 257,
	"./abi_de_cripplinganger.png": 258,
	"./abi_de_cripplingterror.png": 259,
	"./abi_de_crushinganger.png": 260,
	"./abi_de_crushingspite.png": 261,
	"./abi_de_crushtheweak.png": 262,
	"./abi_de_daemonicchill.png": 263,
	"./abi_de_danceofdoom.png": 264,
	"./abi_de_darkpoison.png": 265,
	"./abi_de_darkstarcloak.png": 266,
	"./abi_de_disastrouscascade.png": 267,
	"./abi_de_doombolt.png": 268,
	"./abi_de_dreadaspect.png": 269,
	"./abi_de_drivenbyhate.png": 270,
	"./abi_de_echoofpower.png": 271,
	"./abi_de_elitetraining.png": 272,
	"./abi_de_elixirofinsanepower.png": 273,
	"./abi_de_elixirofmaddenedspeed.png": 274,
	"./abi_de_elixirofthecauldron.png": 275,
	"./abi_de_enchantingbeauty.png": 276,
	"./abi_de_enfeeblingstrike.png": 277,
	"./abi_de_enragedbeating.png": 278,
	"./abi_de_envenomedblade.png": 279,
	"./abi_de_essencelash.png": 280,
	"./abi_de_feedingonweakness.png": 281,
	"./abi_de_fellsacrifice.png": 282,
	"./abi_de_ferociousassault.png": 283,
	"./abi_de_flay.png": 284,
	"./abi_de_fleetfooted.png": 285,
	"./abi_de_flingpoison.png": 286,
	"./abi_de_forceoffury.png": 287,
	"./abi_de_furioushowl.png": 288,
	"./abi_de_gloomburst.png": 289,
	"./abi_de_gloomofnight.png": 290,
	"./abi_de_gripofanger.png": 291,
	"./abi_de_gripoffear.png": 292,
	"./abi_de_groundslam.png": 293,
	"./abi_de_guard.png": 294,
	"./abi_de_handofruin.png": 295,
	"./abi_de_hatefulstrike.png": 296,
	"./abi_de_heartrendertoxin.png": 297,
	"./abi_de_holdtheline.png": 298,
	"./abi_de_horrificwound.png": 299,
	"./abi_de_impendingdoom.png": 300,
	"./abi_de_infernalwave.png": 301,
	"./abi_de_inmalekithsname.png": 302,
	"./abi_de_juggernaut.png": 303,
	"./abi_de_khainesembrace.png": 304,
	"./abi_de_khainesrefreshment.png": 305,
	"./abi_de_khainesvigor.png": 306,
	"./abi_de_khaineswarding.png": 307,
	"./abi_de_khaineswithdrawal.png": 308,
	"./abi_de_kissofagony.png": 309,
	"./abi_de_kissofbetrayal.png": 310,
	"./abi_de_kissofdeath.png": 311,
	"./abi_de_lacerate.png": 312,
	"./abi_de_lifesend.png": 313,
	"./abi_de_maddenedassault.png": 314,
	"./abi_de_manglingcleave.png": 315,
	"./abi_de_mindhole.png": 316,
	"./abi_de_mindkiller.png": 317,
	"./abi_de_monstrousrending.png": 318,
	"./abi_de_murderouswrath.png": 319,
	"./abi_de_noneshallpass.png": 320,
	"./abi_de_obsessivefocus.png": 321,
	"./abi_de_onyourknees.png": 322,
	"./abi_de_overwhelmingdread.png": 323,
	"./abi_de_paralyzingnightmares.png": 324,
	"./abi_de_patchwounds.png": 325,
	"./abi_de_piercearmor.png": 326,
	"./abi_de_pillageessence.png": 327,
	"./abi_de_pitilessstrike.png": 328,
	"./abi_de_pitofshades.png": 329,
	"./abi_de_puncture.png": 330,
	"./abi_de_reapingscythe.png": 331,
	"./abi_de_recklessgathering.png": 332,
	"./abi_de_renewsoul.png": 333,
	"./abi_de_restoration.png": 334,
	"./abi_de_sacrificialstab.png": 335,
	"./abi_de_sanguinaryextension.png": 336,
	"./abi_de_severlimb.png": 337,
	"./abi_de_shadesofdeath.png": 338,
	"./abi_de_shadowknives.png": 339,
	"./abi_de_shadowofdeath.png": 340,
	"./abi_de_shadowprowler.png": 341,
	"./abi_de_shadowspike.png": 342,
	"./abi_de_shatteredshadows.png": 343,
	"./abi_de_shatterenchantment.png": 344,
	"./abi_de_shieldofrage.png": 345,
	"./abi_de_shroudingdarkness.png": 346,
	"./abi_de_slice.png": 347,
	"./abi_de_soulinfusion.png": 348,
	"./abi_de_soulstealer.png": 349,
	"./abi_de_standcoward.png": 350,
	"./abi_de_stickenvoices.png": 351,
	"./abi_de_strickenlimbs.png": 352,
	"./abi_de_surgingpain.png": 353,
	"./abi_de_taunt.png": 354,
	"./abi_de_terryingvision.png": 355,
	"./abi_de_thousandandonedarkblessings.png": 356,
	"./abi_de_throwdagger.png": 357,
	"./abi_de_treacherousassault.png": 358,
	"./abi_de_umbralstrikes.png": 359,
	"./abi_de_uncaringdismissal.png": 360,
	"./abi_de_universalconfusion.png": 361,
	"./abi_de_vehementblades.png": 362,
	"./abi_de_virulentinfusion.png": 363,
	"./abi_de_visionoftorment.png": 364,
	"./abi_de_visionsoftorment.png": 365,
	"./abi_de_warpblast.png": 366,
	"./abi_de_webofshadows.png": 367,
	"./abi_de_whirlinglaceration.png": 368,
	"./abi_de_windwovenshell.png": 369,
	"./abi_de_wordofpain.png": 370,
	"./abi_de_wrackingagony.png": 371,
	"./abi_de_wrackingpains.png": 372,
	"./abi_dw_acidbomb.png": 373,
	"./abi_dw_adamant.png": 374,
	"./abi_dw_addlingshot.png": 375,
	"./abi_dw_ammocompartment.png": 376,
	"./abi_dw_arm01.png": 377,
	"./abi_dw_armor01.png": 378,
	"./abi_dw_armor02.png": 379,
	"./abi_dw_armor04.png": 380,
	"./abi_dw_armoredplating.png": 381,
	"./abi_dw_armorplating.png": 382,
	"./abi_dw_autoloader.png": 383,
	"./abi_dw_avengingthedebt.png": 384,
	"./abi_dw_awaywithye.png": 385,
	"./abi_dw_axetoss.png": 386,
	"./abi_dw_barbedwire.png": 387,
	"./abi_dw_blinding.png": 388,
	"./abi_dw_blindingburst.png": 389,
	"./abi_dw_blunderbussblast.png": 390,
	"./abi_dw_bombardmentturret.png": 391,
	"./abi_dw_breakloose.png": 392,
	"./abi_dw_burnsalve.png": 393,
	"./abi_dw_callartillery.png": 394,
	"./abi_dw_cannonsmash.png": 395,
	"./abi_dw_cavein.png": 396,
	"./abi_dw_chainhot.png": 397,
	"./abi_dw_challenge.png": 398,
	"./abi_dw_charge.png": 399,
	"./abi_dw_cleftintwain.png": 400,
	"./abi_dw_coilbomb.png": 401,
	"./abi_dw_concussiongrenade.png": 402,
	"./abi_dw_counter.png": 403,
	"./abi_dw_crackshot.png": 404,
	"./abi_dw_deadlydetermination.png": 405,
	"./abi_dw_deathblow.png": 406,
	"./abi_dw_deepwound.png": 407,
	"./abi_dw_devastate.png": 408,
	"./abi_dw_disarm01.png": 409,
	"./abi_dw_distractingroar.png": 410,
	"./abi_dw_doomseeker.png": 411,
	"./abi_dw_dwarfen_bowling_buff.png": 412,
	"./abi_dw_earthenrenewal.png": 413,
	"./abi_dw_earthshatter.png": 414,
	"./abi_dw_effectruneofiron.png": 415,
	"./abi_dw_effectruneofpower.png": 416,
	"./abi_dw_effectruneofwarding.png": 417,
	"./abi_dw_electromagnet.png": 418,
	"./abi_dw_empowerment01.png": 419,
	"./abi_dw_empowerment02.png": 420,
	"./abi_dw_enervatingblow.png": 421,
	"./abi_dw_eventheodds.png": 422,
	"./abi_dw_explosion01.png": 423,
	"./abi_dw_explosion02.png": 424,
	"./abi_dw_explosion03.png": 425,
	"./abi_dw_explosion04.png": 426,
	"./abi_dw_explosion05.png": 427,
	"./abi_dw_explosion06.png": 428,
	"./abi_dw_face01.png": 429,
	"./abi_dw_face02.png": 430,
	"./abi_dw_face03.png": 431,
	"./abi_dw_face04.png": 432,
	"./abi_dw_face05.png": 433,
	"./abi_dw_face06.png": 434,
	"./abi_dw_face07.png": 435,
	"./abi_dw_face08.png": 436,
	"./abi_dw_face09.png": 437,
	"./abi_dw_face10.png": 438,
	"./abi_dw_face11.png": 439,
	"./abi_dw_face12.png": 440,
	"./abi_dw_face13.png": 441,
	"./abi_dw_face14.png": 442,
	"./abi_dw_face20.png": 443,
	"./abi_dw_face21.png": 444,
	"./abi_dw_face22.png": 445,
	"./abi_dw_face23.png": 446,
	"./abi_dw_face24.png": 447,
	"./abi_dw_face25.png": 448,
	"./abi_dw_face26.png": 449,
	"./abi_dw_face27.png": 450,
	"./abi_dw_faceshield01.png": 451,
	"./abi_dw_fieldrepair.png": 452,
	"./abi_dw_fierceness.png": 453,
	"./abi_dw_figure01.png": 454,
	"./abi_dw_figure02.png": 455,
	"./abi_dw_figure03.png": 456,
	"./abi_dw_figure04.png": 457,
	"./abi_dw_figure05.png": 458,
	"./abi_dw_figure06.png": 459,
	"./abi_dw_figure07.png": 460,
	"./abi_dw_figure08.png": 461,
	"./abi_dw_figure09.png": 462,
	"./abi_dw_figure10.png": 463,
	"./abi_dw_figure11.png": 464,
	"./abi_dw_figure12.png": 465,
	"./abi_dw_figure13.png": 466,
	"./abi_dw_figure14.png": 467,
	"./abi_dw_figure15.png": 468,
	"./abi_dw_figure16.png": 469,
	"./abi_dw_figure17.png": 470,
	"./abi_dw_figure18.png": 471,
	"./abi_dw_figure21.png": 472,
	"./abi_dw_figure22.png": 473,
	"./abi_dw_figure23.png": 474,
	"./abi_dw_figure24.png": 475,
	"./abi_dw_fist01.png": 476,
	"./abi_dw_fist02.png": 477,
	"./abi_dw_fist03.png": 478,
	"./abi_dw_flameturret.png": 479,
	"./abi_dw_flashbanggrenade.png": 480,
	"./abi_dw_flingexplosives.png": 481,
	"./abi_dw_flurry.png": 482,
	"./abi_dw_foot01.png": 483,
	"./abi_dw_foot02.png": 484,
	"./abi_dw_foot03.png": 485,
	"./abi_dw_foot04.png": 486,
	"./abi_dw_foot06.png": 487,
	"./abi_dw_foot07.png": 488,
	"./abi_dw_foot08.png": 489,
	"./abi_dw_frictionburn.png": 490,
	"./abi_dw_giveall.png": 491,
	"./abi_dw_grievousharm.png": 492,
	"./abi_dw_grimnirfury.png": 493,
	"./abi_dw_gripofstone.png": 494,
	"./abi_dw_gromrilplating.png": 495,
	"./abi_dw_grudgebornfury.png": 496,
	"./abi_dw_grungnisgift.png": 497,
	"./abi_dw_guardedattack.png": 498,
	"./abi_dw_gudrunswarcry.png": 499,
	"./abi_dw_gun01.png": 500,
	"./abi_dw_gunturret.png": 501,
	"./abi_dw_hand01.png": 502,
	"./abi_dw_hand02.png": 503,
	"./abi_dw_hand03.png": 504,
	"./abi_dw_hand04.png": 505,
	"./abi_dw_hand05.png": 506,
	"./abi_dw_heavyblow.png": 507,
	"./abi_dw_hipshot.png": 508,
	"./abi_dw_impendingdoom.png": 509,
	"./abi_dw_incapacitate.png": 510,
	"./abi_dw_invigoration.png": 511,
	"./abi_dw_keg.png": 512,
	"./abi_dw_kidneystrike.png": 513,
	"./abi_dw_kneecapper.png": 514,
	"./abi_dw_knockyesilly.png": 515,
	"./abi_dw_landmine.png": 516,
	"./abi_dw_lightningrod.png": 517,
	"./abi_dw_lookslikeachallenge.png": 518,
	"./abi_dw_madness.png": 519,
	"./abi_dw_master.png": 520,
	"./abi_dw_masterruneoffury.png": 521,
	"./abi_dw_masterruneofsmiting.png": 522,
	"./abi_dw_masterruneofspeed.png": 523,
	"./abi_dw_melee01.png": 524,
	"./abi_dw_melee02.png": 525,
	"./abi_dw_melee03.png": 526,
	"./abi_dw_melee04.png": 527,
	"./abi_dw_melee05.png": 528,
	"./abi_dw_melee06.png": 529,
	"./abi_dw_melee07.png": 530,
	"./abi_dw_melee08.png": 531,
	"./abi_dw_melee09.png": 532,
	"./abi_dw_melee10.png": 533,
	"./abi_dw_melee11.png": 534,
	"./abi_dw_melee12.png": 535,
	"./abi_dw_melee13.png": 536,
	"./abi_dw_melee14.png": 537,
	"./abi_dw_melee15.png": 538,
	"./abi_dw_melee16.png": 539,
	"./abi_dw_melee17.png": 540,
	"./abi_dw_melee18.png": 541,
	"./abi_dw_melee19.png": 542,
	"./abi_dw_melee20.png": 543,
	"./abi_dw_melee21.png": 544,
	"./abi_dw_mountainspirit.png": 545,
	"./abi_dw_napalmgrenade.png": 546,
	"./abi_dw_nitrogrenade.png": 547,
	"./abi_dw_noescape.png": 548,
	"./abi_dw_numbingstrike.png": 549,
	"./abi_dw_oath01.png": 550,
	"./abi_dw_oath02.png": 551,
	"./abi_dw_oathbound.png": 552,
	"./abi_dw_oathfriend.png": 553,
	"./abi_dw_oathruneoffortune.png": 554,
	"./abi_dw_oathruneofhealing.png": 555,
	"./abi_dw_oathruneofiron.png": 556,
	"./abi_dw_oathruneofwarding.png": 557,
	"./abi_dw_oathstone.png": 558,
	"./abi_dw_oilgrenade.png": 559,
	"./abi_dw_onslaught.png": 560,
	"./abi_dw_perilousassault.png": 561,
	"./abi_dw_phosphorousshells.png": 562,
	"./abi_dw_protectionofancestors.png": 563,
	"./abi_dw_pulverizingstrike.png": 564,
	"./abi_dw_rampage.png": 565,
	"./abi_dw_range01.png": 566,
	"./abi_dw_range02.png": 567,
	"./abi_dw_range03.png": 568,
	"./abi_dw_range04.png": 569,
	"./abi_dw_range05.png": 570,
	"./abi_dw_range06.png": 571,
	"./abi_dw_range07.png": 572,
	"./abi_dw_range08.png": 573,
	"./abi_dw_range09.png": 574,
	"./abi_dw_range10.png": 575,
	"./abi_dw_range11.png": 576,
	"./abi_dw_range12.png": 577,
	"./abi_dw_range13.png": 578,
	"./abi_dw_range14.png": 579,
	"./abi_dw_range15.png": 580,
	"./abi_dw_range16.png": 581,
	"./abi_dw_range17.png": 582,
	"./abi_dw_rebirth.png": 583,
	"./abi_dw_recklessgamble.png": 584,
	"./abi_dw_relentlessstrikes.png": 585,
	"./abi_dw_requeststrafingrun.png": 586,
	"./abi_dw_retribution.png": 587,
	"./abi_dw_rockclutch.png": 588,
	"./abi_dw_runeetchedaxe.png": 589,
	"./abi_dw_runeofabsorption.png": 590,
	"./abi_dw_runeofbattle.png": 591,
	"./abi_dw_runeofbinding.png": 592,
	"./abi_dw_runeofbrotherhood.png": 593,
	"./abi_dw_runeofburning.png": 594,
	"./abi_dw_runeofcleaving.png": 595,
	"./abi_dw_runeofending.png": 596,
	"./abi_dw_runeoffire.png": 597,
	"./abi_dw_runeofimmolation.png": 598,
	"./abi_dw_runeoflife.png": 599,
	"./abi_dw_runeofpreservation.png": 600,
	"./abi_dw_runeofredeployment.png": 601,
	"./abi_dw_runeofregeneration.png": 602,
	"./abi_dw_runeofrenascence.png": 603,
	"./abi_dw_runeofrestoration.png": 604,
	"./abi_dw_runeofshielding.png": 605,
	"./abi_dw_runeofskewering.png": 606,
	"./abi_dw_runeofstriking.png": 607,
	"./abi_dw_runeofsundering.png": 608,
	"./abi_dw_runeofsuppression.png": 609,
	"./abi_dw_runicshield.png": 610,
	"./abi_dw_rustgrenade.png": 611,
	"./abi_dw_sanctuary.png": 612,
	"./abi_dw_scattershot.png": 613,
	"./abi_dw_selfdestruct.png": 614,
	"./abi_dw_shatterlimb.png": 615,
	"./abi_dw_shield01.png": 616,
	"./abi_dw_shield02.png": 617,
	"./abi_dw_shield03.png": 618,
	"./abi_dw_shield04.png": 619,
	"./abi_dw_shieldcharge01.png": 620,
	"./abi_dw_shieldofreprisal.png": 621,
	"./abi_dw_shieldsweep.png": 622,
	"./abi_dw_shockgrenade.png": 623,
	"./abi_dw_signalflare.png": 624,
	"./abi_dw_skinofiron.png": 625,
	"./abi_dw_slowdown.png": 626,
	"./abi_dw_smokebomb.png": 627,
	"./abi_dw_snipe.png": 628,
	"./abi_dw_spellbreaker.png": 629,
	"./abi_dw_spelleater.png": 630,
	"./abi_dw_spinecrusher.png": 631,
	"./abi_dw_staticdischarge.png": 632,
	"./abi_dw_steamvent.png": 633,
	"./abi_dw_stonebreaker.png": 634,
	"./abi_dw_stoutness.png": 635,
	"./abi_dw_strengthinnumbers.png": 636,
	"./abi_dw_strike.png": 637,
	"./abi_dw_symbol01.png": 638,
	"./abi_dw_symbol02.png": 639,
	"./abi_dw_symbol04.png": 640,
	"./abi_dw_symbol05.png": 641,
	"./abi_dw_symbol06.png": 642,
	"./abi_dw_symbol07.png": 643,
	"./abi_dw_symbol08.png": 644,
	"./abi_dw_symbol09.png": 645,
	"./abi_dw_symbol10.png": 646,
	"./abi_dw_taunt.png": 647,
	"./abi_dw_throwaxe.png": 648,
	"./abi_dw_triumph.png": 649,
	"./abi_dw_unleashedpower.png": 650,
	"./abi_dw_untouchable.png": 651,
	"./abi_dw_valayasshield.png": 652,
	"./abi_dw_vengefulstrike.png": 653,
	"./abi_dw_wide_swings_buff.png": 654,
	"./abi_dw_wildswing.png": 655,
	"./abi_em_absenceoffaith.png": 656,
	"./abi_em_absolution.png": 657,
	"./abi_em_annihilate.png": 658,
	"./abi_em_arcingswing.png": 659,
	"./abi_em_avatarofsigmar.png": 660,
	"./abi_em_blastoffaith.png": 661,
	"./abi_em_blaze.png": 662,
	"./abi_em_blessbulletsofcleansing.png": 663,
	"./abi_em_blessedbulletsofconfession.png": 664,
	"./abi_em_blessedbulletsofrepentance.png": 665,
	"./abi_em_blessedweapons.png": 666,
	"./abi_em_blessedweaponsofpurging.png": 667,
	"./abi_em_blessedweaponsofpurity.png": 668,
	"./abi_em_bludgeon.png": 669,
	"./abi_em_boilingblood.png": 670,
	"./abi_em_breathofsigmar.png": 671,
	"./abi_em_burnarmor.png": 672,
	"./abi_em_burnawaylies.png": 673,
	"./abi_em_burnheretic.png": 674,
	"./abi_em_burningfaith.png": 675,
	"./abi_em_burninghead.png": 676,
	"./abi_em_burningiron.png": 677,
	"./abi_em_burnout.png": 678,
	"./abi_em_cauterize.png": 679,
	"./abi_em_challenge.png": 680,
	"./abi_em_chokingsmoke.png": 681,
	"./abi_em_confess.png": 682,
	"./abi_em_conflagrationofdoom.png": 683,
	"./abi_em_cower.png": 684,
	"./abi_em_declareanathema.png": 685,
	"./abi_em_deflectingstrike.png": 686,
	"./abi_em_detonate.png": 687,
	"./abi_em_disguise.png": 688,
	"./abi_em_distractingburst.png": 689,
	"./abi_em_divineaegis.png": 690,
	"./abi_em_divineaid.png": 691,
	"./abi_em_divineamazement.png": 692,
	"./abi_em_divinegaze.png": 693,
	"./abi_em_divinelight.png": 694,
	"./abi_em_divinereplenishment.png": 695,
	"./abi_em_divineshock.png": 696,
	"./abi_em_doordie.png": 697,
	"./abi_em_dragongun.png": 698,
	"./abi_em_emperorsblessing.png": 699,
	"./abi_em_exoneration.png": 700,
	"./abi_em_favourablewinds.png": 701,
	"./abi_em_fervor.png": 702,
	"./abi_em_fever.png": 703,
	"./abi_em_fieryblast.png": 704,
	"./abi_em_fireball.png": 705,
	"./abi_em_fireballbarrage.png": 706,
	"./abi_em_firecage.png": 707,
	"./abi_em_firestorm.png": 708,
	"./abi_em_firmresolve.png": 709,
	"./abi_em_flamebreath.png": 710,
	"./abi_em_flameofrhuin.png": 711,
	"./abi_em_flameshield.png": 712,
	"./abi_em_flamingdisaster.png": 713,
	"./abi_em_flare.png": 714,
	"./abi_em_flawlessdefense.png": 715,
	"./abi_em_funnelpower.png": 716,
	"./abi_em_gettheebehindme.png": 717,
	"./abi_em_giftoflife.png": 718,
	"./abi_em_glimpse.png": 719,
	"./abi_em_gloriousassault.png": 720,
	"./abi_em_grandtheogonistsprotection.png": 721,
	"./abi_em_grimdetermination.png": 722,
	"./abi_em_guard.png": 723,
	"./abi_em_guardianoflight.png": 724,
	"./abi_em_hammerofsigmar.png": 725,
	"./abi_em_healinghands.png": 726,
	"./abi_em_heartoffire.png": 727,
	"./abi_em_heavensfury.png": 728,
	"./abi_em_ignite.png": 729,
	"./abi_em_inflammability.png": 730,
	"./abi_em_interception.png": 731,
	"./abi_em_jousting.png": 732,
	"./abi_em_judgement.png": 733,
	"./abi_em_juggernaut.png": 734,
	"./abi_em_lastrites.png": 735,
	"./abi_em_lavafield.png": 736,
	"./abi_em_magicdart.png": 737,
	"./abi_em_martyrsblessing.png": 738,
	"./abi_em_meltarmor.png": 739,
	"./abi_em_myrmidiasfury.png": 740,
	"./abi_em_noescape.png": 741,
	"./abi_em_novastrike.png": 742,
	"./abi_em_nowsourchance.png": 743,
	"./abi_em_onyourguard.png": 744,
	"./abi_em_penance.png": 745,
	"./abi_em_perseverance.png": 746,
	"./abi_em_piousrestoration.png": 747,
	"./abi_em_playingwithfire.png": 748,
	"./abi_em_prayerofabsolution.png": 749,
	"./abi_em_prayerofblessedweapons.png": 750,
	"./abi_em_prayeroflastingdevotion.png": 751,
	"./abi_em_precisestrike.png": 752,
	"./abi_em_presstheattack.png": 753,
	"./abi_em_purgatory.png": 754,
	"./abi_em_purge.png": 755,
	"./abi_em_purify.png": 756,
	"./abi_em_purifyingflames.png": 757,
	"./abi_em_pyroclasticsurge.png": 758,
	"./abi_em_rainoffire.png": 759,
	"./abi_em_razorstrike.png": 760,
	"./abi_em_relicofinnocence.png": 761,
	"./abi_em_relicofpurity.png": 762,
	"./abi_em_relicofthetwintailed.png": 763,
	"./abi_em_rendingstrike.png": 764,
	"./abi_em_repelblasphemy.png": 765,
	"./abi_em_repent.png": 766,
	"./abi_em_repent01.png": 767,
	"./abi_em_righteousblow.png": 768,
	"./abi_em_ruinanddestruction.png": 769,
	"./abi_em_scorchedearth.png": 770,
	"./abi_em_scornofsigmar.png": 771,
	"./abi_em_sear.png": 772,
	"./abi_em_seekersblade.png": 773,
	"./abi_em_shackle.png": 774,
	"./abi_em_shatterconfidence.png": 775,
	"./abi_em_shieldingblaze.png": 776,
	"./abi_em_shieldofaqshy.png": 777,
	"./abi_em_shieldofthesun.png": 778,
	"./abi_em_shiningblade.png": 779,
	"./abi_em_shoottomaim.png": 780,
	"./abi_em_sigilofdestruction.png": 781,
	"./abi_em_sigilofsigmar.png": 782,
	"./abi_em_sigmarsgrace.png": 783,
	"./abi_em_sigmarsshield.png": 784,
	"./abi_em_sigmarsvision.png": 785,
	"./abi_em_sigmarswrath.png": 786,
	"./abi_em_sigmartears.png": 787,
	"./abi_em_silencetheheretic.png": 788,
	"./abi_em_slowburn.png": 789,
	"./abi_em_smash.png": 790,
	"./abi_em_smashinggriposte.png": 791,
	"./abi_em_smashingriposte.png": 792,
	"./abi_em_smite.png": 793,
	"./abi_em_smokescreen.png": 794,
	"./abi_em_snapshot.png": 795,
	"./abi_em_solarflare.png": 796,
	"./abi_em_spreadingflames.png": 797,
	"./abi_em_staggeringimpact.png": 798,
	"./abi_em_standandfight.png": 799,
	"./abi_em_standstrong.png": 800,
	"./abi_em_stayfocused.png": 801,
	"./abi_em_stopdropandroll.png": 802,
	"./abi_em_suddenaccusation.png": 803,
	"./abi_em_supplication.png": 804,
	"./abi_em_supressapostasy.png": 805,
	"./abi_em_sweepingimpact.png": 806,
	"./abi_em_takethemdown.png": 807,
	"./abi_em_taunt.png": 808,
	"./abi_em_throw.png": 809,
	"./abi_em_throwhammer.png": 810,
	"./abi_em_toglory.png": 811,
	"./abi_em_tormenttheunclean.png": 812,
	"./abi_em_tormentthewicked.png": 813,
	"./abi_em_touchofthedivine.png": 814,
	"./abi_em_tovictory.png": 815,
	"./abi_em_trialbypain.png": 816,
	"./abi_em_twintailedfury.png": 817,
	"./abi_em_unbalancingattack.png": 818,
	"./abi_em_unbalancingblow.png": 819,
	"./abi_em_vanhorstmannsspeculum.png": 820,
	"./abi_em_vigilance.png": 821,
	"./abi_em_vowofsilence.png": 822,
	"./abi_em_waveofrighteousness.png": 823,
	"./abi_em_weightofguilt.png": 824,
	"./abi_em_wildfire.png": 825,
	"./abi_em_witheringheat.png": 826,
	"./abi_ge_apprentice.png": 827,
	"./abi_ge_crowdcontrol_immovable.png": 828,
	"./abi_ge_crowdcontrol_unstoppable.png": 829,
	"./abi_ge_master.png": 830,
	"./abi_ge_resolutedefense.png": 831,
	"./abi_ge_shoot.png": 832,
	"./abi_ge_sprint.png": 833,
	"./abi_ge_swing.png": 834,
	"./abi_ge_swingstaff.png": 835,
	"./abi_ge_throw.png": 836,
	"./abi_ge_zap.png": 837,
	"./abi_go_arm01.png": 838,
	"./abi_go_face01.png": 839,
	"./abi_go_face03.png": 840,
	"./abi_gs_arreromork.png": 841,
	"./abi_gs_behindya.png": 842,
	"./abi_gs_bigslash.png": 843,
	"./abi_gs_bigswing.png": 844,
	"./abi_gs_bunchowaaagh.png": 845,
	"./abi_gs_canthitme.png": 846,
	"./abi_gs_canttouchus.png": 847,
	"./abi_gs_chokingarrer.png": 848,
	"./abi_gs_cutya.png": 849,
	"./abi_gs_dabiggest.png": 850,
	"./abi_gs_dabigun.png": 851,
	"./abi_gs_dachallenge.png": 852,
	"./abi_gs_deafeningwaaagh.png": 853,
	"./abi_gs_degreenest.png": 854,
	"./abi_gs_donthitme.png": 855,
	"./abi_gs_dropthat.png": 856,
	"./abi_gs_eadbutt.png": 857,
	"./abi_gs_eeeek.png": 858,
	"./abi_gs_explodinarrer.png": 859,
	"./abi_gs_eyquitbleedin.png": 860,
	"./abi_gs_feelinnopain.png": 861,
	"./abi_gs_feelznopain.png": 862,
	"./abi_gs_fickskin.png": 863,
	"./abi_gs_finishemoff.png": 864,
	"./abi_gs_fistsofgork.png": 865,
	"./abi_gs_followmelead.png": 866,
	"./abi_gs_footstab.png": 867,
	"./abi_gs_getemlads.png": 868,
	"./abi_gs_getsmarter.png": 869,
	"./abi_gs_gimmie.png": 870,
	"./abi_gs_gorksbarbs.png": 871,
	"./abi_gs_gorksbelch.png": 872,
	"./abi_gs_gorksbuffer.png": 873,
	"./abi_gs_greenerncleaner.png": 874,
	"./abi_gs_lemmeout.png": 875,
	"./abi_gs_lifeleaka.png": 876,
	"./abi_gs_lobchoppa.png": 877,
	"./abi_gs_lotsofshootin.png": 878,
	"./abi_gs_morksprotection.png": 879,
	"./abi_gs_notindaface.png": 880,
	"./abi_gs_notsofast.png": 881,
	"./abi_gs_poisonarrer.png": 882,
	"./abi_gs_puddleomuck.png": 883,
	"./abi_gs_quityersquabbin.png": 884,
	"./abi_gs_rottenarrer.png": 885,
	"./abi_gs_runaway.png": 886,
	"./abi_gs_runnshoot.png": 887,
	"./abi_gs_savedarunts.png": 888,
	"./abi_gs_shrapnelarrer.png": 889,
	"./abi_gs_skullthumper.png": 890,
	"./abi_gs_spinnslash.png": 891,
	"./abi_gs_squigarmor.png": 892,
	"./abi_gs_squigbeast.png": 893,
	"./abi_gs_squigfrenzy.png": 894,
	"./abi_gs_stealyerthunder.png": 895,
	"./abi_gs_stickysquig.png": 896,
	"./abi_gs_stophittinme.png": 897,
	"./abi_gs_tasteslikechicken.png": 898,
	"./abi_gs_treehitcombo.png": 899,
	"./abi_gs_tuffernnails.png": 900,
	"./abi_gs_waaagh.png": 901,
	"./abi_gs_waitigotmore.png": 902,
	"./abi_gs_walkitoff.png": 903,
	"./abi_gs_wezbigger.png": 904,
	"./abi_gs_whatarmor.png": 905,
	"./abi_gs_whereyougoing.png": 906,
	"./abi_gs_windupdawaaagh.png": 907,
	"./abi_gs_wotarmor.png": 908,
	"./abi_gs_yamissedme.png": 909,
	"./abi_gs_yerbleedin.png": 910,
	"./abi_gs_yernothin.png": 911,
	"./abi_gs_youzsquishy.png": 912,
	"./abi_he_acidarrow.png": 913,
	"./abi_he_aethyricarmor.png": 914,
	"./abi_he_aethyricgrasp.png": 915,
	"./abi_he_arteryshot.png": 916,
	"./abi_he_assaultstance.png": 917,
	"./abi_he_axetoss.png": 918,
	"./abi_he_baitingstrike.png": 919,
	"./abi_he_balanceessence.png": 920,
	"./abi_he_bite.png": 921,
	"./abi_he_bladeandclaw.png": 922,
	"./abi_he_bladeofleapinggold.png": 923,
	"./abi_he_bladeshield.png": 924,
	"./abi_he_blessingofisha.png": 925,
	"./abi_he_blindinglight.png": 926,
	"./abi_he_blindside.png": 927,
	"./abi_he_blurringshock.png": 928,
	"./abi_he_boonofhyshr.png": 929,
	"./abi_he_brutalassault.png": 930,
	"./abi_he_brutalpounce.png": 931,
	"./abi_he_callwarlion.png": 932,
	"./abi_he_carefulaim.png": 933,
	"./abi_he_challenge.png": 934,
	"./abi_he_charge.png": 935,
	"./abi_he_clawsweep.png": 936,
	"./abi_he_cleansingflare.png": 937,
	"./abi_he_cleansinglight.png": 938,
	"./abi_he_cleavelimb.png": 939,
	"./abi_he_closingshot.png": 940,
	"./abi_he_coordinatestrike.png": 941,
	"./abi_he_counterblow.png": 942,
	"./abi_he_coweringbeasts.png": 943,
	"./abi_he_crashingwave.png": 944,
	"./abi_he_criticalshot.png": 945,
	"./abi_he_crushingadvance.png": 946,
	"./abi_he_culltheweak.png": 947,
	"./abi_he_disspatingenergies.png": 948,
	"./abi_he_distractingshot.png": 949,
	"./abi_he_distractingstrike.png": 950,
	"./abi_he_dominance.png": 951,
	"./abi_he_dragonstrike.png": 952,
	"./abi_he_drainmagic.png": 953,
	"./abi_he_drawblood.png": 954,
	"./abi_he_echoingroar.png": 955,
	"./abi_he_embodimentofminaith.png": 956,
	"./abi_he_emodimentofthalui.png": 957,
	"./abi_he_emodimentofurithair.png": 958,
	"./abi_he_ensnare.png": 959,
	"./abi_he_ensorcelledblow.png": 960,
	"./abi_he_escalatinghealth.png": 961,
	"./abi_he_etherdance.png": 962,
	"./abi_he_exploitweakness.png": 963,
	"./abi_he_eyeshot.png": 964,
	"./abi_he_fangandclaw.png": 965,
	"./abi_he_felinegrace.png": 966,
	"./abi_he_felltheweak.png": 967,
	"./abi_he_festeringarrow.png": 968,
	"./abi_he_festeringwound.png": 969,
	"./abi_he_fetch.png": 970,
	"./abi_he_feyillusion.png": 971,
	"./abi_he_firststrike.png": 972,
	"./abi_he_flamesofthephoenix.png": 973,
	"./abi_he_flankingshot.png": 974,
	"./abi_he_forceopportunity.png": 975,
	"./abi_he_freedom.png": 976,
	"./abi_he_funnelenergy.png": 977,
	"./abi_he_furyofasuryan.png": 978,
	"./abi_he_giftoflife.png": 979,
	"./abi_he_gracefulsweep.png": 980,
	"./abi_he_grimslash.png": 981,
	"./abi_he_gryphonslash.png": 982,
	"./abi_he_guard.png": 983,
	"./abi_he_guardofsteel.png": 984,
	"./abi_he_gutrip.png": 985,
	"./abi_he_hack.png": 986,
	"./abi_he_healingenergy.png": 987,
	"./abi_he_heavensblade.png": 988,
	"./abi_he_instilfear.png": 989,
	"./abi_he_intimidatingblow.png": 990,
	"./abi_he_joyofthehunt.png": 991,
	"./abi_he_lambentaura.png": 992,
	"./abi_he_lawofage.png": 993,
	"./abi_he_lawofconductivity.png": 994,
	"./abi_he_lawoffrailty.png": 995,
	"./abi_he_lawofgold.png": 996,
	"./abi_he_legtear.png": 997,
	"./abi_he_leoninefrenzy.png": 998,
	"./abi_he_lionsfury.png": 999,
	"./abi_he_lionsroar.png": 1000,
	"./abi_he_magicalinfusion.png": 1001,
	"./abi_he_maul.png": 1002,
	"./abi_he_mindlash.png": 1003,
	"./abi_he_mistressofthemarsh.png": 1004,
	"./abi_he_multishot.png": 1005,
	"./abi_he_naturesblade.png": 1006,
	"./abi_he_naturesbond.png": 1007,
	"./abi_he_opportunisticstrike.png": 1008,
	"./abi_he_packassault.png": 1009,
	"./abi_he_penetratingarrow.png": 1010,
	"./abi_he_phantomsblade.png": 1011,
	"./abi_he_phoenixclaw.png": 1012,
	"./abi_he_pindown.png": 1013,
	"./abi_he_portentoffar.png": 1014,
	"./abi_he_pounce.png": 1015,
	"./abi_he_primalfury.png": 1016,
	"./abi_he_prismaticshield.png": 1017,
	"./abi_he_protectionofhoeth.png": 1018,
	"./abi_he_quickincision.png": 1019,
	"./abi_he_radiantglaze.png": 1020,
	"./abi_he_radiantlance.png": 1021,
	"./abi_he_rainlord.png": 1022,
	"./abi_he_rainlord02.png": 1023,
	"./abi_he_rainofsteel.png": 1024,
	"./abi_he_rampage.png": 1025,
	"./abi_he_rapidfire.png": 1026,
	"./abi_he_redirectforce.png": 1027,
	"./abi_he_runningshot.png": 1028,
	"./abi_he_scatterthewinds.png": 1029,
	"./abi_he_scoutstance.png": 1030,
	"./abi_he_searingtouch.png": 1031,
	"./abi_he_shadowblades.png": 1032,
	"./abi_he_shadowssting.png": 1033,
	"./abi_he_shatteringblow.png": 1034,
	"./abi_he_shieldofsphery.png": 1035,
	"./abi_he_shieldofvalor.png": 1036,
	"./abi_he_shotofcynath.png": 1037,
	"./abi_he_shotofsethai.png": 1038,
	"./abi_he_shred.png": 1039,
	"./abi_he_signaloursnipers.png": 1040,
	"./abi_he_skinofstone.png": 1041,
	"./abi_he_skirmishstance.png": 1042,
	"./abi_he_slashingblade.png": 1043,
	"./abi_he_spiralfletchedarrow.png": 1044,
	"./abi_he_stormofcronos.png": 1045,
	"./abi_he_submission.png": 1046,
	"./abi_he_sunderingchop.png": 1047,
	"./abi_he_sweepingslash.png": 1048,
	"./abi_he_swiftstrike.png": 1049,
	"./abi_he_switchfootwork.png": 1050,
	"./abi_he_taunt.png": 1051,
	"./abi_he_terrifyingroar.png": 1052,
	"./abi_he_thebeastunleashed.png": 1053,
	"./abi_he_thintheherd.png": 1054,
	"./abi_he_throatbite.png": 1055,
	"./abi_he_throatshot.png": 1056,
	"./abi_he_throw.png": 1057,
	"./abi_he_trainedtohunt.png": 1058,
	"./abi_he_trainedtokill.png": 1059,
	"./abi_he_trainedtothreaten.png": 1060,
	"./abi_he_unsuspectingstrike.png": 1061,
	"./abi_he_vengenceofnagarthe.png": 1062,
	"./abi_he_vortex.png": 1063,
	"./abi_he_walkbetweenworlds.png": 1064,
	"./abi_he_wallofdartingsteel.png": 1065,
	"./abi_he_weightedarrow.png": 1066,
	"./abi_he_whirlingaxe01.png": 1067,
	"./abi_he_whirlingaxe02.png": 1068,
	"./abi_he_whirlingdervish.png": 1069,
	"./abi_he_whirlinggeyser.png": 1070,
	"./abi_he_whirlingpin.png": 1071,
	"./abi_he_whisperingwind.png": 1072,
	"./abi_he_windsprotection.png": 1073,
	"./abi_he_wingsofheaven.png": 1074,
	"./abi_he_wrathofhoeth.png": 1075,
	"./abi_or_arm01.png": 1076,
	"./abi_or_armor01.png": 1077,
	"./abi_or_berserk.png": 1078,
	"./abi_or_bite.png": 1079,
	"./abi_or_bleedemout.png": 1080,
	"./abi_or_blood01.png": 1081,
	"./abi_or_blood02.png": 1082,
	"./abi_or_blood03.png": 1083,
	"./abi_or_bringdapain.png": 1084,
	"./abi_or_bringiton.png": 1085,
	"./abi_or_cantstopdachop.png": 1086,
	"./abi_or_charge.png": 1087,
	"./abi_or_chopfasta.png": 1088,
	"./abi_or_claw01.png": 1089,
	"./abi_or_claw02.png": 1090,
	"./abi_or_combo01.png": 1091,
	"./abi_or_combo02.png": 1092,
	"./abi_or_comeangitit.png": 1093,
	"./abi_or_counter.png": 1094,
	"./abi_or_crotch01.png": 1095,
	"./abi_or_dattickles.png": 1096,
	"./abi_or_dontgonowhere.png": 1097,
	"./abi_or_dropdabasha.png": 1098,
	"./abi_or_face01.png": 1099,
	"./abi_or_face02.png": 1100,
	"./abi_or_face03.png": 1101,
	"./abi_or_face04.png": 1102,
	"./abi_or_face05.png": 1103,
	"./abi_or_face06.png": 1104,
	"./abi_or_face07.png": 1105,
	"./abi_or_face09.png": 1106,
	"./abi_or_face10.png": 1107,
	"./abi_or_face11.png": 1108,
	"./abi_or_face12.png": 1109,
	"./abi_or_face13.png": 1110,
	"./abi_or_face14.png": 1111,
	"./abi_or_face15.png": 1112,
	"./abi_or_face16.png": 1113,
	"./abi_or_face17.png": 1114,
	"./abi_or_face18.png": 1115,
	"./abi_or_face19.png": 1116,
	"./abi_or_face20.png": 1117,
	"./abi_or_face21.png": 1118,
	"./abi_or_face22.png": 1119,
	"./abi_or_figure01.png": 1120,
	"./abi_or_figure02.png": 1121,
	"./abi_or_figure03.png": 1122,
	"./abi_or_figure04.png": 1123,
	"./abi_or_figure05.png": 1124,
	"./abi_or_figure06.png": 1125,
	"./abi_or_figure07.png": 1126,
	"./abi_or_figure08.png": 1127,
	"./abi_or_figure09.png": 1128,
	"./abi_or_figure10.png": 1129,
	"./abi_or_figure11.png": 1130,
	"./abi_or_figure12.png": 1131,
	"./abi_or_figure13.png": 1132,
	"./abi_or_figure14.png": 1133,
	"./abi_or_figure15.png": 1134,
	"./abi_or_figure16.png": 1135,
	"./abi_or_figure17.png": 1136,
	"./abi_or_figure18.png": 1137,
	"./abi_or_figure19.png": 1138,
	"./abi_or_figure20.png": 1139,
	"./abi_or_figure21.png": 1140,
	"./abi_or_figure22.png": 1141,
	"./abi_or_figure23.png": 1142,
	"./abi_or_foot01.png": 1143,
	"./abi_or_foot02.png": 1144,
	"./abi_or_foot03.png": 1145,
	"./abi_or_foot04.png": 1146,
	"./abi_or_footstab.png": 1147,
	"./abi_or_furiouschoppin.png": 1148,
	"./abi_or_gitstuckin.png": 1149,
	"./abi_or_gittodachoppa.png": 1150,
	"./abi_or_gofordasoftspot.png": 1151,
	"./abi_or_hand01.png": 1152,
	"./abi_or_hand02.png": 1153,
	"./abi_or_hand03.png": 1154,
	"./abi_or_hand04.png": 1155,
	"./abi_or_hand05.png": 1156,
	"./abi_or_hurtintime.png": 1157,
	"./abi_or_keeponchoppin.png": 1158,
	"./abi_or_lotsachoppin.png": 1159,
	"./abi_or_melee01.png": 1160,
	"./abi_or_melee02.png": 1161,
	"./abi_or_melee03.png": 1162,
	"./abi_or_melee04.png": 1163,
	"./abi_or_melee05.png": 1164,
	"./abi_or_melee06.png": 1165,
	"./abi_or_melee07.png": 1166,
	"./abi_or_melee08.png": 1167,
	"./abi_or_melee09.png": 1168,
	"./abi_or_melee10.png": 1169,
	"./abi_or_melee11.png": 1170,
	"./abi_or_melee12.png": 1171,
	"./abi_or_melee13.png": 1172,
	"./abi_or_melee14.png": 1173,
	"./abi_or_melee15.png": 1174,
	"./abi_or_melee16.png": 1175,
	"./abi_or_melee17.png": 1176,
	"./abi_or_melee18.png": 1177,
	"./abi_or_melee19.png": 1178,
	"./abi_or_melee20.png": 1179,
	"./abi_or_mob.png": 1180,
	"./abi_or_mushroom01.png": 1181,
	"./abi_or_mushroom02.png": 1182,
	"./abi_or_mushroom03.png": 1183,
	"./abi_or_nofightinback.png": 1184,
	"./abi_or_nomorehelpin.png": 1185,
	"./abi_or_outamyface.png": 1186,
	"./abi_or_plink.png": 1187,
	"./abi_or_pokeindaeye.png": 1188,
	"./abi_or_range01.png": 1189,
	"./abi_or_range02.png": 1190,
	"./abi_or_range03.png": 1191,
	"./abi_or_range04.png": 1192,
	"./abi_or_range05.png": 1193,
	"./abi_or_recklessblow.png": 1194,
	"./abi_or_runaway.png": 1195,
	"./abi_or_sharpbits.png": 1196,
	"./abi_or_shield01.png": 1197,
	"./abi_or_shrugitoff.png": 1198,
	"./abi_or_sitdown.png": 1199,
	"./abi_or_slasha.png": 1200,
	"./abi_or_sleep.png": 1201,
	"./abi_or_speedyfeet.png": 1202,
	"./abi_or_squig01.png": 1203,
	"./abi_or_squig02.png": 1204,
	"./abi_or_squig03.png": 1205,
	"./abi_or_squig04.png": 1206,
	"./abi_or_squig05.png": 1207,
	"./abi_or_squig06.png": 1208,
	"./abi_or_squig07.png": 1209,
	"./abi_or_squig08.png": 1210,
	"./abi_or_squig09.png": 1211,
	"./abi_or_squig11.png": 1212,
	"./abi_or_squig12.png": 1213,
	"./abi_or_squig13.png": 1214,
	"./abi_or_squig14.png": 1215,
	"./abi_or_squig15.png": 1216,
	"./abi_or_squig16.png": 1217,
	"./abi_or_stabbity.png": 1218,
	"./abi_or_stompdayard.png": 1219,
	"./abi_or_supachop.png": 1220,
	"./abi_or_symbol01.png": 1221,
	"./abi_or_symbol02.png": 1222,
	"./abi_or_symbol03.png": 1223,
	"./abi_or_tantrum.png": 1224,
	"./abi_or_throatslasha.png": 1225,
	"./abi_or_throwaxe.png": 1226,
	"./abi_or_tiredalready.png": 1227,
	"./abi_or_tossbigun.png": 1228,
	"./abi_or_tryanhurtme.png": 1229,
	"./abi_or_waaagh.png": 1230,
	"./abi_or_weaklinkilla.png": 1231,
	"./abi_or_wildswing.png": 1232,
	"./abi_or_wotsdarush.png": 1233,
	"./abi_or_yerallbleedinnow.png": 1234,
	"./abi_or_yergoindown.png": 1235,
	"./abi_siege_abatewarmachine.png": 1236,
	"./abi_siege_boobytrap.png": 1237,
	"./abi_siege_bulwark.png": 1238,
	"./abi_siege_bypassdefense.png": 1239,
	"./abi_siege_cleansewarmachine.png": 1240,
	"./abi_siege_deflectoil.png": 1241,
	"./abi_siege_diminishwarmachine.png": 1242,
	"./abi_siege_enchantedammunition.png": 1243,
	"./abi_siege_faultfinder.png": 1244,
	"./abi_siege_hamperwarmachine.png": 1245,
	"./abi_siege_hexwarmachine.png": 1246,
	"./abi_siege_improveammunition.png": 1247,
	"./abi_siege_lockpick.png": 1248,
	"./abi_siege_modifywarmachine.png": 1249,
	"./abi_siege_reinforcewarmachine.png": 1250,
	"./abi_siege_shieldtheskies.png": 1251,
	"./abi_siege_siegewreaker.png": 1252,
	"./abi_squig_ardnoggin.png": 1253,
	"./abi_squig_badgas.png": 1254,
	"./abi_squig_bite.png": 1255,
	"./abi_squig_bounce.png": 1256,
	"./abi_squig_claw01.png": 1257,
	"./abi_squig_claw02.png": 1258,
	"./abi_squig_goopshootin.png": 1259,
	"./abi_squig_gore.png": 1260,
	"./abi_squig_headbutt.png": 1261,
	"./abi_squig_indigestion.png": 1262,
	"./abi_squig_poisonedspine.png": 1263,
	"./abi_squig_shout.png": 1264,
	"./abi_squig_spikeshield.png": 1265,
	"./abi_squig_spines.png": 1266,
	"./abi_squig_sporecloud.png": 1267,
	"./all_bit_mac_apple_01.png": 1268,
	"./all_bit_mac_apple_02.png": 1269,
	"./all_bit_nightofmurder.png": 1270,
	"./archetype_defsupport.png": 1271,
	"./archetype_dps.png": 1272,
	"./archetype_healer.png": 1273,
	"./archetype_healer_alterfate.png": 1274,
	"./archetype_healer_divinefavor.png": 1275,
	"./archetype_healer_divineprotection.png": 1276,
	"./archetype_healer_focusedmind.png": 1277,
	"./archetype_healer_rampagingsiphon.png": 1278,
	"./archetype_healer_steal life.png": 1279,
	"./archetype_meleedps_broadswings.png": 1280,
	"./archetype_meleedps_confusingmovements.png": 1281,
	"./archetype_meleedps_forceofwill.png": 1282,
	"./archetype_meleedps_frenziedslaughter.png": 1283,
	"./archetype_meleedps_relentlessassault.png": 1284,
	"./archetype_meleedps_severnerve.png": 1285,
	"./archetype_offsupport.png": 1286,
	"./archetype_rangeddpsbow_concealment.png": 1287,
	"./archetype_rangeddpsbow_explosiveshots.png": 1288,
	"./archetype_rangeddpsbow_hailofdoom.png": 1289,
	"./archetype_rangeddpsbow_pointblank.png": 1290,
	"./archetype_rangeddpsbow_unshakablefocus.png": 1291,
	"./archetype_rangeddpsmagic_magebolt.png": 1292,
	"./archetype_rangeddpsmagic_misdirection.png": 1293,
	"./archetype_rangeddpsmagic_scintillatingenergy.png": 1294,
	"./archetype_rangeddpsmagic_siphonpower.png": 1295,
	"./archetype_rangeddpsmagic_unleashthewinds.png": 1296,
	"./archetype_tank.png": 1297,
	"./archetype_tank_demolishingstrike.png": 1298,
	"./archetype_tank_distractingbellow.png": 1299,
	"./archetype_tank_grapple.png": 1300,
	"./archetype_tank_immaculatedefense.png": 1301,
	"./archetype_tank_raze.png": 1302,
	"./archetype_tank_shieldwall.png": 1303,
	"./class_apprentice.png": 1304,
	"./class_archer.png": 1305,
	"./class_archmage.png": 1306,
	"./class_blackorc.png": 1307,
	"./class_bleaksword.png": 1308,
	"./class_brideofkhaine.png": 1309,
	"./class_brightwizard.png": 1310,
	"./class_chosen.png": 1311,
	"./class_daboyz.png": 1312,
	"./class_dwarfwarrior.png": 1313,
	"./class_engineer.png": 1314,
	"./class_goblin.png": 1315,
	"./class_haggraef.png": 1316,
	"./class_magus.png": 1317,
	"./class_marauder.png": 1318,
	"./class_nightgoblin.png": 1319,
	"./class_oathbreaker.png": 1320,
	"./class_runescribe.png": 1321,
	"./class_sorcerer.png": 1322,
	"./class_squire.png": 1323,
	"./class_swordsman.png": 1324,
	"./class_warriorpriest.png": 1325,
	"./class_whitelion.png": 1326,
	"./class_zealot.png": 1327,
	"./stat_agl.png": 1328,
	"./stat_bal.png": 1329,
	"./stat_ini.png": 1330,
	"./stat_int.png": 1331,
	"./stat_str.png": 1332,
	"./stat_tou.png": 1333,
	"./stat_wil.png": 1334,
	"./stat_wou.png": 1335,
	"./stat_ws.png": 1336,
	"./statbuff_acumen.png": 1337,
	"./statbuff_agility.png": 1338,
	"./statbuff_arcanedismissal.png": 1339,
	"./statbuff_arcaneprotection.png": 1340,
	"./statbuff_assault.png": 1341,
	"./statbuff_blademaster.png": 1342,
	"./statbuff_defender.png": 1343,
	"./statbuff_discipline.png": 1344,
	"./statbuff_fireproof.png": 1345,
	"./statbuff_focusedpower.png": 1346,
	"./statbuff_fortitude.png": 1347,
	"./statbuff_impetus.png": 1348,
	"./statbuff_marksmen.png": 1349,
	"./statbuff_might.png": 1350,
	"./statbuff_naturalfighter.png": 1351,
	"./statbuff_opportunist.png": 1352,
	"./statbuff_reflexes.png": 1353,
	"./statbuff_reinforcement.png": 1354,
	"./statbuff_resilient.png": 1355,
	"./statbuff_resolve.png": 1356,
	"./statbuff_sage.png": 1357,
	"./statbuff_sharpshooter.png": 1358,
	"./statbuff_skirmisher.png": 1359,
	"./statbuff_spiritualrefinement.png": 1360,
	"./statbuff_sureshot.png": 1361,
	"./statbuff_unbending.png": 1362,
	"./statbuff_vigor.png": 1363,
	"./tac_blue_banner01.png": 1364,
	"./tac_blue_chaos01.png": 1365,
	"./tac_blue_crown01.png": 1366,
	"./tac_blue_darkelf01.png": 1367,
	"./tac_blue_dwarf01.png": 1368,
	"./tac_blue_empire01.png": 1369,
	"./tac_blue_generic01.png": 1370,
	"./tac_blue_generic02.png": 1371,
	"./tac_blue_greenskin01.png": 1372,
	"./tac_blue_healing01.png": 1373,
	"./tac_blue_highelf01.png": 1374,
	"./tac_blue_magical01.png": 1375,
	"./tac_blue_magical02.png": 1376,
	"./tac_blue_melee01.png": 1377,
	"./tac_blue_melee02.png": 1378,
	"./tac_blue_money01.png": 1379,
	"./tac_blue_potion01.png": 1380,
	"./tac_blue_range01.png": 1381,
	"./tac_blue_range02.png": 1382,
	"./tac_blue_skull01.png": 1383,
	"./tac_blue_tome01.png": 1384,
	"./tac_blue_utility01.png": 1385,
	"./tac_defensive_generic.png": 1386,
	"./tac_defensive_magical.png": 1387,
	"./tac_defensive_melee.png": 1388,
	"./tac_defensive_range.png": 1389,
	"./tac_green_banner01.png": 1390,
	"./tac_green_chaos01.png": 1391,
	"./tac_green_crown01.png": 1392,
	"./tac_green_darkelf01.png": 1393,
	"./tac_green_dwarf01.png": 1394,
	"./tac_green_empire01.png": 1395,
	"./tac_green_generic01.png": 1396,
	"./tac_green_generic02.png": 1397,
	"./tac_green_greenskin01.png": 1398,
	"./tac_green_healing01.png": 1399,
	"./tac_green_highelf01.png": 1400,
	"./tac_green_magical01.png": 1401,
	"./tac_green_magical02.png": 1402,
	"./tac_green_melee01.png": 1403,
	"./tac_green_melee02.png": 1404,
	"./tac_green_money01.png": 1405,
	"./tac_green_potion01.png": 1406,
	"./tac_green_range01.png": 1407,
	"./tac_green_range02.png": 1408,
	"./tac_green_skull01.png": 1409,
	"./tac_green_tome01.png": 1410,
	"./tac_green_utility01.png": 1411,
	"./tac_grey_banner01.png": 1412,
	"./tac_grey_chaos01.png": 1413,
	"./tac_grey_crown01.png": 1414,
	"./tac_grey_darkelf01.png": 1415,
	"./tac_grey_dwarf01.png": 1416,
	"./tac_grey_empire01.png": 1417,
	"./tac_grey_generic01.png": 1418,
	"./tac_grey_generic02.png": 1419,
	"./tac_grey_greenskin01.png": 1420,
	"./tac_grey_healing01.png": 1421,
	"./tac_grey_highelf01.png": 1422,
	"./tac_grey_magical01.png": 1423,
	"./tac_grey_magical02.png": 1424,
	"./tac_grey_melee01.png": 1425,
	"./tac_grey_melee02.png": 1426,
	"./tac_grey_money01.png": 1427,
	"./tac_grey_potion01.png": 1428,
	"./tac_grey_range01.png": 1429,
	"./tac_grey_range02.png": 1430,
	"./tac_grey_skull01.png": 1431,
	"./tac_grey_tome01.png": 1432,
	"./tac_grey_utility01.png": 1433,
	"./tac_offensive_generic.png": 1434,
	"./tac_offensive_magical.png": 1435,
	"./tac_offensive_melee.png": 1436,
	"./tac_offensive_range.png": 1437,
	"./tac_red_banner01.png": 1438,
	"./tac_red_chaos01.png": 1439,
	"./tac_red_crown01.png": 1440,
	"./tac_red_darkelf01.png": 1441,
	"./tac_red_dwarf01.png": 1442,
	"./tac_red_empire01.png": 1443,
	"./tac_red_generic01.png": 1444,
	"./tac_red_generic02.png": 1445,
	"./tac_red_greenskin01.png": 1446,
	"./tac_red_healing01.png": 1447,
	"./tac_red_highelf01.png": 1448,
	"./tac_red_magical01.png": 1449,
	"./tac_red_magical02.png": 1450,
	"./tac_red_melee01.png": 1451,
	"./tac_red_melee02.png": 1452,
	"./tac_red_money01.png": 1453,
	"./tac_red_potion01.png": 1454,
	"./tac_red_range01.png": 1455,
	"./tac_red_range02.png": 1456,
	"./tac_red_skull01.png": 1457,
	"./tac_red_tome01.png": 1458,
	"./tac_red_utility01.png": 1459,
	"./tac_utility.png": 1460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1471;